import { createFileRoute } from "@tanstack/react-router";
import ProductHubList from "@/pages/ProductHubList";

export const Route = createFileRoute("/chainsaws/reviews")({
  component: () => <ProductHubList hubSlug="chainsaws" variant="reviews" />,
});
